import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=019f51bb&scoped=true&"
import script from "./NavbarComponent.vue?vue&type=script&lang=ts&"
export * from "./NavbarComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=019f51bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f51bb",
  null
  
)

export default component.exports